export function updateField(fieldName, value, viewer, bIsReadOnly = true) {
  let field = viewer.formFieldCollection.find((x) => x.name === fieldName);
  viewer.formDesignerModule.updateFormField(field, {
    isReadOnly: false,
    value: value.toString(),
  });
  if (bIsReadOnly === true) {
    viewer.formDesignerModule.updateFormField(field, {
      backgroundColor: "transparent",
    });
  }
  viewer.formDesignerModule.updateFormField(field, {
    isReadOnly: bIsReadOnly,
  });
}

export function makeFieldsVisible(viewer) {
  viewer.formFieldCollection.forEach((field) => {
    viewer.formDesignerModule.updateFormField(field, {
      backgroundColor: "#daeaf700",
    });
  });
}

export function signatureIsValid(signature) {
  if (
    signature.value !== "" &&
    signature.signatureType !== "" &&
    "signatureBound" in signature
  ) {
    return true;
  } else {
    return false;
  }
}
export function allRadioFieldsChecked(allFields) {
  let reducedFields = allFields.reduce((acc, cur) => {
    if (acc[cur.name] === undefined) {
      acc[cur.name] = [cur];
    } else if (acc[cur.name] !== undefined) {
      acc[cur.name].push(cur);
    }
    return acc;
  }, {});
  let allRadioFields = [];
  for (let field in reducedFields) {
    if (reducedFields[field].length > 1) {
      allRadioFields.push(reducedFields[field]);
    }
  }
  let allRadioFieldsChecked = allRadioFields.every((radioGroup) => {
    let oneIsSelected = radioGroup.some((field) => field.isSelected === true);
    if (oneIsSelected) return true;
    else return false;
  });
  return allRadioFieldsChecked;
}
export function declineRadioSelected(allFields) {
  let reducedFields = allFields.reduce((acc, cur) => {
    if (acc[cur.name] === undefined) {
      acc[cur.name] = [cur];
    } else if (acc[cur.name] !== undefined) {
      acc[cur.name].push(cur);
    }
    return acc;
  }, {});
  let allRadioFields = [];
  for (let field in reducedFields) {
    if (reducedFields[field].length > 1) {
      allRadioFields.push(reducedFields[field]);
    }
  }

  let declineRadioSelected = allRadioFields.every((radioGroup) => {
    let oneIsSelected = radioGroup.some(
      (field) => field.value === "Decline" && field.isSelected === true
    );

    if (oneIsSelected) {
      return true;
    } else if (
      radioGroup[1] !== undefined &&
      radioGroup[1].properties !== undefined &&
      radioGroup[1].name === "Acceptance"
    ) {
      //Had to add this logic because we could not get the Spanish version of
      //  Electronic Signature Agreement to pass values with the radio buttons.
      //  This logic works as long as the second radio button in the group is for Decline
      //  Note that the name property above is the radio button Group name
      return radioGroup[1].properties.isSelected;
    } else {
      return false;
    }
  });
  return declineRadioSelected;
}
export function allRequiredFieldsFilled(allFields) {
  // TODO : figure out how to deal with with both radio and text and check boxes?
  let reducedFields = allFields.reduce((acc, cur) => {
    if (acc[cur.name] === undefined) {
      acc[cur.name] = [cur];
    } else {
      acc[cur.name].push(cur);
    }
    return acc;
  }, {});
  let allRequiredFilled = true;
  for (let field in reducedFields) {
    let curField = reducedFields[field];
    if (reducedFields[field].length > 1) {
      // deal with radio buttons
      let oneIsSelected = reducedFields[field].some(
        (f) => f.isSelected === true
      );
      if (!oneIsSelected) {
        allRequiredFilled = false;
        break;
      }
    } else {
      // text fields vs check boxes?
      // text field
      if (curField[0].isRequired && curField[0].value === "") {
        allRequiredFilled = false;
        break;
      }
      // check box ???
    }
  }
  return allRequiredFilled;
}

export function allFieldsReadOnly(viewer) {
  let allReadOnly = viewer.formFieldCollection.map((field) => {
    viewer.formDesignerModule.updateFormField(field, { isReadOnly: true });
    return field;
  });
  let allReadOnlyIsTrue = allReadOnly.every(
    (field) => field.isReadonly === true
  );
  return allReadOnlyIsTrue;
}

export function signaturesReadOnly(viewer) {
  let signaturesSetReadOnly = viewer.formFieldCollection.filter((field) => {
    if (field.formFieldAnnotationType === "SignatureField") {
      viewer.formDesignerModule.updateFormField(field, { isReadOnly: true });
      return field;
    }
  });
  let allSignaturesReadOnlyIsTrue = signaturesSetReadOnly.every((field) => {
    return field.isReadonly === true;
  });
  return allSignaturesReadOnlyIsTrue;
}

export function removeFieldsBackgroundColor(viewer) {
  viewer.formFieldCollection.map((field) => {
    viewer.formDesignerModule.updateFormField(field, {
      backgroundColor: "transparent",
    });
  });
}
